// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() { 
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.pageScrollHandler(); // 首页页面滚动处理
    this.bannerTryBtnHandler(); // 首页Banner 试用按钮
    this.videoHandler(); // 视频处理
    this.aiSecureSwitchHandler(); // AI共建切换处理
    this.foundationImgSwitchHandler(); // AI基座切换处理
    this.dataGovernanceSwitchHandler(); // 数据治理切换处理
    this.lowCodeTabHandler(); //低零代码构建能力Tab处理
    this.whitepaperDownloadHandler(); // 下载白皮书处理
  },
  pageScrollHandler(){
    // 监听区块进入视口，添加动画class
    const $sections = $('section');
    const observer = new IntersectionObserver(function (entries) {
      $.each(entries, function (_, item) {
        if (item.isIntersecting) {
          $(item.target).addClass('active');
        }
      });
    }, { threshold: 0.2 });

    $sections.each(function () {
      observer.observe(this);
    });

    // 滚轮滚动防抖，优化滚动动画手感
    let scrollLock = false;
    $(window).on('wheel', function () {
      if (scrollLock) return;
      scrollLock = true;
      setTimeout(() => {
        scrollLock = false;
      }, 800);
    });
  },
  bannerTryBtnHandler() {
    $("#bannerTryBtn").on('click', function(e) {
      // 阻止默认的点击行为
      e.preventDefault();
      // 获取链接参数
      const params = JSON.parse(localStorage.getItem('params'));
      // 获取链接的href属性
      const url = $(this).attr('href');
      const queryString = params ? Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&') : '';
      location.href = queryString ? `${url}?${queryString}` : url;
    })
  },
  videoHandler() {
    const $wrap = $('#aiInteractVideo');
    const $video = $('#aiInteractVideoEl');
    const $poster = $('#aiInteractPoster');
    const $btn = $('#aiInteractPlayBtn');
    let playing = false;
    // 全部元素存在才绑定事件
    if ($wrap.length && $video.length && $poster.length && $btn.length) {
      $wrap.on('click', function (e) {
        e.preventDefault();
        if (!playing) {
          $poster.addClass('hidden');
          $btn.addClass('hidden');
          $video[0].play();
          playing = true;
        }
      });
    }
  },
  aiSecureSwitchHandler() {
    const footerData = [
      [
        { title: '云端大模型', tag: '大模型', desc: '对接云端大模型服务<br>兼顾灵活性与数据安全' },
        { title: 'Ollama 私有部署', tag: '私有化', desc: '支持 Ollama 等本地化部署<br>数据不出域，安全可控' },
        { title: '多模态理解', tag: '多模态', desc: '覆盖语言、视觉、图像等<br>多模态模型统一接入' },
        { title: '推理与生成', tag: '推理', desc: '内置 prompt 模板与管理<br>高效推理与内容生成' }
      ],
      [
        { title: '低零代码搭建', tag: '搭建', desc: '拖拽式可视化设计<br>无需编写代码即可完成应用搭建' },
        { title: '流程引擎', tag: '流程', desc: '全生命周期流程编排引擎<br>复杂业务流程轻松管理' },
        { title: '表单设计', tag: '表单', desc: '在线可视化表单设计<br>支持复杂表单交互逻辑' },
        { title: '接口管理', tag: '接口', desc: '统一 API 接口管理<br>标准化开放接口，安全鉴权' }
      ],
      [
        { title: 'RAG 检索增强', tag: 'RAG', desc: '检索增强生成技术<br>提升大模型回答准确率' },
        { title: '私有知识库', tag: '知识库', desc: '共建企业私有知识库<br>沉淀业务经验与专业能力' },
        { title: '语义理解', tag: '语义', desc: '自然语言语义理解<br>精准匹配业务意图' },
        { title: '垂直领域', tag: '垂直', desc: '补齐垂直领域知识短板<br>赋能行业深度应用' }
      ],
      [
        { title: '自动化工具', tag: '自动化', desc: '可复用 AI 自动化工具<br>降低重复性人工操作' },
        { title: 'MCP 协议', tag: 'MCP', desc: '标准化 Model-Context-Protocol<br>跨模型工具互通' },
        { title: '智能体编排', tag: '智能体', desc: '复杂多智能体编排<br>协同完成业务任务' },
        { title: '业务操作', tag: '操作', desc: 'AI 自主执行业务操作<br>不止思考，更能执行' }
      ]
    ];
    
    // 更新底部卡片文字
    function updateFooter($section, idx) {
      const $footer = $section.find('.ai-secure-footer');
      if (!$footer.length) return;
      const $items = $footer.find('li');
      const data = footerData[idx];
      if (!data) return;

      $items.each(function (i) {
        const $li = $(this);
        const item = data[i];
        $li.find('.asf-title span').text(item.title);
        $li.find('.asf-msg span').text(item.tag);
        $li.find('.asf-msg p').html(item.desc);
      });
    }

    // 初始化每个 ai-secure-section
    function initAiSecureSections() {
      $('.ai-secure-section').each(function () {
        const $section = $(this);
        // 已初始化跳过
        if ($section.data('aiSecureReady') === 1) return;
        $section.data('aiSecureReady', 1);

        let activeIdx = 0;
        const $collapse = $section.find('.ai-secure-collapse');
        if (!$collapse.length) return;

        const $tabs = $collapse.find('li');
        const $slides = $section.find('.ai-secure-slide');
        const $slidesTrack = $section.find('.ai-secure-slides');
        const isCopySection = $section.attr('id') === 'aiCardSectionCopy';
        let switching = false;
        let switchTimer = null;

        // 切换面板与轮播
        function switchAiSecure(idx, force) {
          if (idx === activeIdx) return;
          if (!isCopySection && switching && !force) return;
          if (!$tabs.eq(idx).length || !$slides.eq(idx).length) return;

          if (!isCopySection) {
            switching = true;
            $collapse.addClass('is-switching');
          }

          // 移除旧激活
          $tabs.eq(activeIdx).removeClass('active');
          $slides.eq(activeIdx).removeClass('active');
          // 新激活
          $tabs.eq(idx).addClass('active');
          $slides.eq(idx).addClass('active');

          // 滑动容器位移
          if ($slidesTrack.length) {
            $slidesTrack.css('transform', `translateY(-${idx * 25}%)`);
          }

          activeIdx = idx;

          if (!isCopySection) {
            updateFooter($section, idx);
            clearTimeout(switchTimer);
            switchTimer = setTimeout(() => {
              switching = false;
              $collapse.removeClass('is-switching');
            }, 580);
          }
        }

        // 绑定鼠标移入、点击
        $tabs.each(function () {
          const $tab = $(this);
          const tabIdx = Number($tab.data('idx'));
          $tab
            .on('mouseenter', () => switchAiSecure(tabIdx))
            .on('click', () => switchAiSecure(tabIdx, true));
        });
      });
    }
    // DOM就绪直接执行
    initAiSecureSections();
  },
  foundationImgSwitchHandler() {

    // 图片数组
    const foundationLeftImgs = [
      '/static/default/pc/2026/images/index/foundation-icon-1.webp',
      '/static/default/pc/2026/images/index/foundation-icon-2.webp',
      '/static/default/pc/2026/images/index/foundation-icon-3.webp'
    ];
    const foundationRightImgs = [
      '/static/default/pc/2026/images/index/foundation-icon-4.webp',
      '/static/default/pc/2026/images/index/foundation-icon-5.webp',
      '/static/default/pc/2026/images/index/foundation-icon-6.webp'
    ];

    // 左侧卡片切换
    $('.foundation-left .foundation-card').on('mouseenter', function(e){
      const $this = $(this);
      // 阻止默认的点击行为
      e.preventDefault();
      // 移除所有卡片active
      $('.foundation-left .foundation-card, .foundation-right .foundation-card').removeClass('active');
      
      // 当前卡片激活
      $this.addClass('active')
      
      // 获取下标切换图片
      const idx = parseInt($this.data('idx'));
      $('#foundationImg').attr('src', foundationLeftImgs[idx]);
    })

    // 右侧卡片切换
    $('.foundation-right .foundation-card').on('mouseenter', function(e){
      const $this = $(this);
      // 阻止默认的点击行为
      e.preventDefault();
      // 移除所有卡片active
      $('.foundation-left .foundation-card, .foundation-right .foundation-card').removeClass('active');
      // 当前卡片激活
      $this.addClass('active');
      
      // 获取下标切换图片
      const idx = parseInt($this.data('idx'));
      $('#foundationImg').attr('src', foundationRightImgs[idx]);

    })
  },
  dataGovernanceSwitchHandler() {
    const $dataGovernanceCards = $('.data-governance-card');
    let activeIdx = 0;
    const normalWidth = 'calc((100% - 36rem - 5rem) / 4)';
    const activeWidth = '36rem';

    // 初始化第一张激活
    const $first = $dataGovernanceCards.eq(activeIdx);
    $first.css('width', activeWidth);
    $first.find('.card-active').css({
      opacity: 1,
      visibility: 'visible'
    });

    // 鼠标移入事件
    $dataGovernanceCards.each(function (i) {
      const $current = $(this);
      $current.on('mouseenter', function () {
        if (activeIdx === i) return;

        // 还原上一张
        const $prev = $dataGovernanceCards.eq(activeIdx);
        $prev.css('width', normalWidth);
        $prev.find('.card-active').css({
          opacity: 0,
          visibility: 'hidden'
        });

        // 激活当前卡片
        $current.css('width', activeWidth);
        $current.find('.card-active').css({
          opacity: 1,
          visibility: 'visible'
        });

        activeIdx = i;
      });
    });
  },
  lowCodeTabHandler(){
    $('.low-code-tab-item').on('mouseenter', function(e){
        // 阻止默认的点击行为
        e.preventDefault();
        const $this = $(this);
        const idx = $this.attr('data-idx')

        // 1. 切换tab激活态
        $this.addClass('active').siblings().removeClass('active');

        // 2. 根据下标，给对应内容项加active，其他移除
        $('.low-code-con-item').removeClass('active');
        $(`.low-code-con-item[data-idx="${idx}"]`).addClass('active');
    })
  },
  whitepaperDownloadHandler() {
    // 下载白皮书
    $(".wp-download-btn, .wp-card-download-btn").on('click', function(e) {
      // 阻止默认的点击行为
      e.preventDefault();
      $('.whitepaper-modal-overlay').addClass('active');
      // 禁用页面滚动
      $('body').addClass('scroll-lock');
    })
    // 关闭按钮
    $(".whitepaper-close-btn").on('click', function(e) {
      // 阻止默认的点击行为
      e.preventDefault();
      $('.whitepaper-modal-overlay').removeClass('active');
      // 恢复页面滚动
      $('body').removeClass('scroll-lock');
    })
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
